import { render } from "./ResetPasswordForm.vue?vue&type=template&id=45f33db6&scoped=true"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=js"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=js"

import "./ResetPasswordForm.vue?vue&type=style&index=0&id=45f33db6&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f33db6"]])

export default __exports__